@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/shared/components/glass-house-shelf-talker-content/glass-house-shelf-talker-item/glass-house-shelf-talker-item.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.glass-house-shelf-talker-item {
  width: 100%;
  height: 4.625rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-content: center;
  gap: 0.375rem;
  --badge-grid-min-col: 1rem;
}
.glass-house-shelf-talker-item .brand-logo-and-badges {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.glass-house-shelf-talker-item .brand-logo-and-badges .brand-logo {
  height: 3.5rem;
  width: 3.5rem;
  object-fit: contain;
  align-content: center;
}
.glass-house-shelf-talker-item .brand-logo-and-badges .badges {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
}
.glass-house-shelf-talker-item .brand-logo-and-badges .badges .badge {
  width: 1rem;
  height: 1rem;
}
.glass-house-shelf-talker-item .prices-and-label {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.glass-house-shelf-talker-item .prices-and-label .price-container {
  display: flex;
  flex-direction: row;
}
.glass-house-shelf-talker-item .prices-and-label .price-container .pricing-headers {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.25rem;
}
.glass-house-shelf-talker-item .prices-and-label .price-container .pricing-headers .pricing-header {
  font-family: inter, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 0.5625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: transparent;
  line-height: 0.625rem;
  padding-right: 0.125rem;
  height: 1.375rem;
}
.glass-house-shelf-talker-item .prices-and-label .price-container .prices {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.25rem;
}
.glass-house-shelf-talker-item .prices-and-label .price-container .prices .price {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 1.375rem;
}
.glass-house-shelf-talker-item .prices-and-label .price-container .prices .price ::ng-deep .shelf-talker-price {
  font-family: inter, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 0.8125rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.glass-house-shelf-talker-item .prices-and-label .price-container .prices .price ::ng-deep .shelf-talker-price .dollar-sign {
  font-size: 0.5em;
}
.glass-house-shelf-talker-item .prices-and-label .price-container .prices .price ::ng-deep .shelf-talker-price .price-decimal {
  font-size: 0.5em;
}
.glass-house-shelf-talker-item .prices-and-label .price-container .prices .price ::ng-deep .shelf-talker-price .price-range-divider {
  line-height: 100%;
}
.glass-house-shelf-talker-item .prices-and-label .price-container .prices .price ::ng-deep .shelf-talker-price .force-bold-style {
  font-family: inter, sans-serif;
  font-weight: 900;
  font-style: normal;
}
.glass-house-shelf-talker-item .prices-and-label .price-container .prices .price ::ng-deep .shelf-talker-price .force-italic-style {
  font-family: inter, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.glass-house-shelf-talker-item .prices-and-label .pre-tax {
  opacity: 0.38;
}
.glass-house-shelf-talker-item .prices-and-label .shelf-talker-label ::ng-deep .product-label {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 0.5rem;
  margin-left: 0;
  width: fit-content;
}
.glass-house-shelf-talker-item.larger {
  height: 5.625rem;
  gap: 0.625rem;
}
.glass-house-shelf-talker-item.larger .brand-logo-and-badges .brand-logo {
  height: 4.4375rem;
  width: 4.4374rem;
}
.glass-house-shelf-talker-item.larger .brand-logo-and-badges .badges {
  gap: 0.5rem;
}
.glass-house-shelf-talker-item.larger .brand-logo-and-badges .badges .badge {
  width: 1.25rem;
  height: 1.25rem;
}
.glass-house-shelf-talker-item.larger .prices-and-label {
  gap: 0.5rem;
}
.glass-house-shelf-talker-item.larger .prices-and-label .price-container .pricing-headers {
  gap: 0.5rem;
}
.glass-house-shelf-talker-item.larger .prices-and-label .price-container .pricing-headers .pricing-header {
  font-size: 0.75rem;
  line-height: 0.875rem;
  padding-right: 0.375rem;
  height: 1.625rem;
}
.glass-house-shelf-talker-item.larger .prices-and-label .prices {
  gap: 0.5rem;
}
.glass-house-shelf-talker-item.larger .prices-and-label .prices .price {
  height: 1.625rem;
}
.glass-house-shelf-talker-item.larger .prices-and-label .prices .price ::ng-deep .shelf-talker-price {
  font-size: 1rem;
}
.glass-house-shelf-talker-item.larger .prices-and-label .shelf-talker-label ::ng-deep .product-label {
  font-size: 0.625rem;
}
/*# sourceMappingURL=glass-house-shelf-talker-item.component.css.map */
